import { StrictMode } from 'react';

import Stack from '@mui/material/Stack';
import ReactDOM from 'react-dom/client';

import { GlobalStyles } from 'theme/globalStyles';
import { processNextUrl } from 'utils/navigation';
import { initSentry } from 'utils/sentry';

import Quote from './App';

// https://vite.dev/guide/build.html#load-error-handling
// Vite preload error handling for dynamic imports
// moved to index.tsx because of this issue: https://github.com/vitejs/vite/discussions/15897
window.addEventListener('vite:preloadError', () => {
  const KEY = 'reload-attempts';
  const MAX_ATTEMPTS = 3;

  try {
    // safetly mechanism in case of infinite loop
    const numberOfAttempts = parseInt(sessionStorage.getItem(KEY) ?? '0', 10);

    if (numberOfAttempts < MAX_ATTEMPTS) {
      sessionStorage.setItem(KEY, String(numberOfAttempts + 1));
      window.location.reload();
    }
  } catch (error) {
    console.error('Session storage error:', error);
  }
});

initSentry();

// routing listener
window.addEventListener('message', (event) => {
  const message = event.data;

  processNextUrl(message.type);
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <StrictMode>
    <GlobalStyles />
    <Stack
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      p={0}
      m={0}
    >
      <Quote />
    </Stack>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
